/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FileManagementEditFileResponse } from "./FileManagementEditFileResponse";

export type FileManagementEditFileResponseApiRespoonse = {
  data?: FileManagementEditFileResponse;
  status?: FileManagementEditFileResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FileManagementEditFileResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
